(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brijnath-language-switch"]) return;
  try {
    
(function(){
  const init=()=>{
    const link=document.querySelector('[data-brijnath-direct-language]');
    if(!link||link.dataset.bound==='true')return;
    link.dataset.bound='true';
    link.addEventListener('click',function(){
      if(link.classList.contains('is-switching'))return;
      link.classList.add('is-switching');
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brijnath-preferences"]) return;
  try {
    
(function(){
  const root=document.documentElement;
  const key='brijnath-theme-mode';
  const getStored=()=>{try{return localStorage.getItem(key)}catch(e){return null}};
  const systemDark=()=>window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches;
  const syncToggle=dark=>{
    const toggle=document.querySelector('[data-brijnath-theme-toggle]');
    if(toggle){toggle.classList.toggle('is-dark',dark);toggle.setAttribute('aria-pressed',dark?'true':'false');toggle.setAttribute('aria-label',dark?'Switch to light mode':'Switch to dark mode');}
  };
  const setMode=(dark,save=true)=>{
    root.classList.toggle('brijnath-dark',dark);
    root.dataset.brijnathTheme=dark?'dark':'light';
    syncToggle(dark);
    if(save){try{localStorage.setItem(key,dark?'dark':'light')}catch(e){}}
  };
  const stored=getStored();
  setMode(stored?stored==='dark':systemDark(),false);
  const init=()=>{
    const toggle=document.querySelector('[data-brijnath-theme-toggle]');
    if(toggle&&!toggle.dataset.bound){toggle.dataset.bound='true';toggle.addEventListener('click',()=>setMode(!root.classList.contains('brijnath-dark'),true));}

    const languageSwitch=document.querySelector('[data-brijnath-language-switch]');
    if(languageSwitch&&!languageSwitch.dataset.bound){
      languageSwitch.dataset.bound='true';
      languageSwitch.addEventListener('click',function(event){
        if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
        event.preventDefault();
        this.classList.add('is-switching');
        const destination=this.href;
        window.setTimeout(()=>{window.location.assign(destination)},260);
      });
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-dinacharya-path"] && !Shopify.designMode) return;
  try {
    
function smInitDinacharyaPath(root){
  (root || document).querySelectorAll('.sm-path').forEach(function(section){
    var track = section.querySelector('.sm-path__track');
    var svg = section.querySelector('.sm-path__wave');
    var pathEl = section.querySelector('.sm-path__wave-path');
    var nodes = section.querySelectorAll('.sm-path__node');
    if(!track || !svg || !pathEl || nodes.length < 2) return;

    function draw(){
      // No viewport gate here on purpose — this must run and animate at every width,
      // including mobile's vertical stack, not just the desktop zigzag row.
      var trackRect = track.getBoundingClientRect();
      if(trackRect.width === 0 || trackRect.height === 0) return;
      svg.setAttribute('viewBox', '0 0 ' + trackRect.width + ' ' + trackRect.height);

      var pts = [];
      nodes.forEach(function(n){
        var r = n.getBoundingClientRect();
        pts.push([
          (r.left + r.width / 2) - trackRect.left,
          (r.top + r.height / 2) - trackRect.top
        ]);
      });

      var d = 'M' + pts[0][0] + ',' + pts[0][1] + ' ';
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[i - 1] || pts[i];
        var p1 = pts[i];
        var p2 = pts[i + 1];
        var p3 = pts[i + 2] || p2;
        var c1x = p1[0] + (p2[0] - p0[0]) / 6;
        var c1y = p1[1] + (p2[1] - p0[1]) / 6;
        var c2x = p2[0] - (p3[0] - p1[0]) / 6;
        var c2y = p2[1] - (p3[1] - p1[1]) / 6;
        d += 'C' + c1x + ',' + c1y + ' ' + c2x + ',' + c2y + ' ' + p2[0] + ',' + p2[1] + ' ';
      }
      pathEl.setAttribute('d', d.trim());
    }

    draw();
    window.addEventListener('resize', draw);
    window.addEventListener('orientationchange', draw);
    window.addEventListener('load', draw);
    if (window.ResizeObserver) {
      new ResizeObserver(draw).observe(track);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(draw);
    }
  });
}
smInitDinacharyaPath();
document.addEventListener('shopify:section:load', function(e){ smInitDinacharyaPath(e.target); });

  } catch(e) { console.error(e); }
})();
})();
